export default "/_next/static/images/3DModel-03765c5c818fd46ee63a666053217aad.png";